// Utility to add admin Authorization header to all fetch calls
export const adminFetch = (url, options = {}) => {
  const token = sessionStorage.getItem('admin_token');
  if (token) {
    const headers = options.headers instanceof Headers 
      ? Object.fromEntries(options.headers.entries()) 
      : { ...(options.headers || {}) };
    headers['Authorization'] = `Bearer ${token}`;
    options = { ...options, headers };
  }
  return fetch(url, options);
};
